<ui-page-content-layout content [(sidebarVisible)]="isFilterVisible">
  <ng-container headerContent>
    <h2 class="text-2xl">Список парковок</h2>

    <div class="flex flex-row gap-2">
      <!-- <ui-button type="primary" size="small" (click)="onOpenDetailsModal()">
        <ui-icon name="plus" size="20px"></ui-icon>
        <span> Добавить </span>
      </ui-button>
      <ui-button
        uiFileImport
        type="primary"
        color="accent"
        size="small"
        (fileSelected)="onImport($event)"
        [disabled]="isImporting"
      >
        <ui-icon name="plus" size="20px"></ui-icon>
        <span> Импорт </span>
      </ui-button> -->
      <ui-button type="secondary" size="small" (click)="onFilterCollapsed()">
        <ui-icon name="filter" size="20px"></ui-icon>
        <span> Фильтр </span>
      </ui-button>
    </div>
  </ng-container>

  <div content class="content-wrapper">
    <ui-table
      [config]="tableConfig"
      [loading]="loading"
      [data]="listData"
      [total]="total"
      [(pageSize)]="pageSize"
      [(pageIndex)]="pageIndex"
      (updateTableData)="loadDataFromServer()"
      (actionClicked)="onTableActionClicked($event)"
    ></ui-table>
  </div>

  <ui-filter
    collapsibleContent
    [form]="filterForm"
    [formConfig]="filterFormConfig"
    (filterClosed)="onFilterCollapsed()"
    (filterApplied)="applyFilter()"
  ></ui-filter>
</ui-page-content-layout>
